import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Minus, Plus } from "lucide-react";

const clamp = (v) => Math.max(0, Math.min(10, Math.round(v * 10) / 10));

// 0–10, one decimal. Empty = not rated ("—" on the sheet).
export default function ScoreInput({ value, onChange, testid, size = "md", disabled }) {
  const step = (d) => onChange(clamp((value == null || value === "" ? 7 : Number(value)) + d));
  const h = size === "sm" ? "h-7" : "h-9";
  return (
    <div className="flex items-center gap-1" data-testid={testid}>
      <Button type="button" size="icon" variant="outline" disabled={disabled} className={`${h} w-7 shrink-0`} onClick={() => step(-0.1)} data-testid={`${testid}-minus`}><Minus className="h-3 w-3" /></Button>
      <Input type="number" inputMode="decimal" min="0" max="10" step="0.1" disabled={disabled} value={value ?? ""} placeholder="—"
        onChange={(e) => { const v = e.target.value; onChange(v === "" ? null : clamp(Number(v))); }}
        className={`${h} w-[4.5rem] text-center font-semibold text-[#153E32]`} data-testid={`${testid}-input`} />
      <Button type="button" size="icon" variant="outline" disabled={disabled} className={`${h} w-7 shrink-0`} onClick={() => step(0.1)} data-testid={`${testid}-plus`}><Plus className="h-3 w-3" /></Button>
    </div>
  );
}
